import { routes } from "@constants/routes";
import { PlusIcon, Typography } from "@cpj-ai/panel-npm-package";
import { Button, Card } from "@heroui/react";
import { useNavigate } from "react-router-dom";

const NewJobPositionCard = () => {
  const navigate = useNavigate();

  const goToAddJobPositionPage = () => {
    navigate(routes.jobPositions.add);
  };

  return (
    <Card className="bg-primary-50 px-4 py-3 shadow-none flex flex-col lg:flex-row justify-between items-center gap-4">
      <Typography variant="p">Create a job posting and hire the best workforce for your company.</Typography>
      <Button
        color="primary"
        onPress={() => {
          goToAddJobPositionPage();
        }}
        startContent={<PlusIcon className="w-6 h-6 stroke-white mt-0.5" />}
      >
        Create New Job Post
      </Button>
    </Card>
  );
};

export default NewJobPositionCard;
